<template>
  <div class="ethos-container no-bg m-3 border-top-0 bg-content">
    <el-tabs
      v-model="activeName"
      type="border-card"
    >
      <!-- TODO: - Re-Add transcription searches AND make sure panes only load when visible -->
      <el-tab-pane
        label="Transcriptions"
        name="transcriptions"
      >
        <transcriptions />
      </el-tab-pane>
      <el-tab-pane
        :label="uploadsNameLabel"
        name="uploads"
      >
        <uploads :reuse="true" />
      </el-tab-pane>
      <el-tab-pane
        :label="casesNameLabel"
        name="cases"
      >
        <cases :reuse="true" />
      </el-tab-pane>
      <el-tab-pane
        :label="projectNameLabel"
        name="projects"
      >
        <projects-list />
      </el-tab-pane>
      <el-tab-pane
        :label="peopleNameLabel"
        name="people"
      >
        <people-list />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import Cases from "../Cases/Cases.vue";
import Uploads from "../Uploads/Uploads.vue";
import Transcriptions from "../Uploads/Transcriptions.vue";
import PeopleList from "../People/PeopleList.vue";
import ProjectsList from "../Projects/ProjectsList.vue";

export default {
  components: {Cases, Uploads, Transcriptions, ProjectsList, PeopleList},
  name: "ethos-search",
  data() {
    return {
      activeName: "transcriptions",
    };
  },
  computed: {
    ...mapGetters("data", [
      "uploadsNameLabel",
      "casesNameLabel",
      "peopleNameLabel",
      "projectNameLabel",
    ]),
  },
  methods: {
    ...mapMutations("data", [
      "setSearchKeyword",
    ]),
  },
  destroyed() {
    this.setSearchKeyword({keyword: ""});
    const searchBar = document.querySelector(".ethosSearch");
    if (searchBar) {
      searchBar.value = "";
    }
  },
};
</script>
